/**
 * how long to allow useQuery to wait before refetch
 */
export const QUERY_STALE_TIME = 3 * 60 * 1000;
